<!-- This example requires Tailwind CSS v2.0+ -->
<template>
  <div>
    <h3 class="text-lg leading-6 font-medium text-gray-900">Statistics</h3>
    <dl class="mt-5 grid grid-cols-1 gap-5 sm:grid-cols-3">
      <BaseCard v-for="item in stats" :key="item.name">
        <BaseCardBody>
          <dt class="text-sm font-medium text-gray-500 truncate">
            {{ item.name }}
          </dt>
          <dd class="mt-1 text-3xl font-semibold text-gray-900">
            {{ item.stat }}
          </dd>
        </BaseCardBody>
      </BaseCard>
    </dl>
  </div>
</template>

<script>
export default {
  props: {
    contactList: {
      type: Object,
      required: true,
    },
  },
  computed: {
    stats() {
      const {
        subscriptions_count: totalSubscriptions = 0,
        active_subscriptions_count: totalActiveSubscriptions = 0,
      } = this.contactList;
      const totalUnsubscribed = totalSubscriptions - totalActiveSubscriptions;
      return [
        { name: 'Total Subscribers', stat: totalSubscriptions },
        { name: 'Active Subscribers', stat: totalActiveSubscriptions },
        { name: 'Unsubscribed', stat: totalUnsubscribed },
      ];
    },
  },
};
</script>
